<script>
export default {
  name: 'MapMarkerTooltip',
  data () {
    return {
      tooltipVisible: false,
      tooltipText: '',
      tooltipStyle: {
        top: '0px',
        left: '0px'
      }
    }
  },
  methods: {
    showTooltip (event, map, {id, nome, grvs}) {
      this.tooltipText = this.createHtml(`${nome} (ID: ${id})`, grvs)
      this.tooltipVisible = true

      this.$nextTick(() => {
        const tooltip = this.$refs.mapTooltip
        const mapContainer = map

        const tooltipRect = tooltip.getBoundingClientRect()
        const mapRect = mapContainer.getBoundingClientRect()

        let top = event.pageY
        let left = event.pageX

        const ultrapassaBordaSuperior = top - tooltipRect.height < mapRect.top
        const ultrapassaBordaInferior = top + tooltipRect.height > mapRect.bottom
        const ultrapassaBordaDireita = left + tooltipRect.width > mapRect.right
        const ultrapassaBordaEsquerda = left - tooltipRect.width < mapRect.left

        const padding = 10

        if (ultrapassaBordaSuperior) {
          top = mapRect.top + tooltipRect.height + padding
        } else if (ultrapassaBordaInferior) {
          let {height} = tooltipRect
          if (height > 55) { // 55 é a altura da tooltip quando o reboque está disponível
            height /= 2
          }
          top = mapRect.bottom - height - padding
        }

        if (ultrapassaBordaDireita) {
          left = mapRect.right - tooltipRect.width - padding
        }

        if (ultrapassaBordaEsquerda) {
          left = mapRect.left + (tooltipRect.width / 2) + padding
        }

        this.tooltipStyle = {
          top: `${top}px`,
          left: `${left}px`
        }
      })
    },

    hideTooltip () {
      this.tooltipVisible = false
    },

    createHtml (title, grvs) {
      const html = []
      const liStyle = `
      border-bottom: 1px solid #ccc;
      padding: 3px auto;
      `
      grvs = grvs.map(({numero, placa}) => {
        placa = placa ? placa.toUpperCase() : '-'
        return `<li style="${liStyle}"><i class="fa fa-car"></i> ${numero} (Reboque: ${placa})</li>`
      })

      html.push(`<i class="fa fa-user"></i> <strong>${title.toUpperCase()}</strong>`)

      if (grvs.length) {
        html.push(`<ul style="list-style: none; padding: 0; margin: 10px 0 0;">`)
        grvs.forEach(grv => html.push(grv))
        html.push(`</ul>`)
      } else {
        html.push('<div><i>Disponível</i></div>')
      }

      return html.join('')
    },

    addListener (map, marker, reboque) {
      marker.element.addEventListener('mouseover', (event) => {
        this.showTooltip(event, map, reboque)
      })
      marker.element.addEventListener('mouseout', () => {
        this.hideTooltip()
      })
    }
  }
}
</script>

<template>
  <div id="tooltip" ref="mapTooltip" class="tooltip" v-if="tooltipVisible" :style="tooltipStyle" v-html="tooltipText"></div>
</template>

<style scoped>
.tooltip {
  position: absolute;
  background-color: white;
  border: 2px solid lightslategrey;
  color: #333;
  padding: 5px 10px;
  border-radius: 5px;
  white-space: nowrap;
  font-size: 14px;
  pointer-events: none; /* Para evitar que interfira no mouseover */
  transform: translate(-50%, -100%);
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// MapMarkerTooltip.vue?b4441df8